export type ReservationConfirmationEmailPayload = {
  reservationId: string;
  guestLabel: string;
  recipientEmail: string;
  arrival: string;
  departure: string;
  roomTypeId: string;
  totalAmount: number;
  currency: string;
};

export type ReservationConfirmationEmailResult = {
  providerId: string;
  messageId: string;
};

export interface ReservationConfirmationEmailProvider {
  sendReservationConfirmation(payload: ReservationConfirmationEmailPayload): Promise<ReservationConfirmationEmailResult>;
}

export class InMemoryReservationConfirmationEmailProvider implements ReservationConfirmationEmailProvider {
  readonly providerId = "in-memory";
  readonly deliveries: ReservationConfirmationEmailPayload[] = [];

  async sendReservationConfirmation(payload: ReservationConfirmationEmailPayload): Promise<ReservationConfirmationEmailResult> {
    this.deliveries.push(payload);
    return {
      providerId: this.providerId,
      messageId: `msg-${this.deliveries.length.toString().padStart(4, "0")}`,
    };
  }
}

